/* src/app/forms/produtos/mercadolivre/mercadolivre.component.css */
:host {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=mercadolivre.component.css.map */
